import { Typography } from '@trellis/roots/typography'

const AMOUNT_DUE_COPY: Record<string, string> = {
  PAID: 'Paid in full.',
  CANCELLED: 'Cancelled — no payment expected.',
  VOID: 'Voided — kept for records.',
  OVERDUE: 'Overdue — payment expected.',
  DRAFT: 'Not yet sent.',
  SENT: 'Awaiting payment.',
}

export interface InvoiceAmountDueCardProps {
  status: string
  amountDueValue: string
  total: number
  currFmt: Intl.NumberFormat
}

export function InvoiceAmountDueCard({
  status,
  amountDueValue,
  total,
  currFmt,
}: InvoiceAmountDueCardProps) {
  return (
    <div className="rounded-xl border p-5">
      <Typography variant="overline" color="muted">
        Amount due
      </Typography>
      <div className="mt-2.5 flex items-baseline gap-1">
        <span className="text-muted-foreground text-sm">$</span>
        <span
          className="leading-none tabular-nums"
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 900,
            fontSize: 38,
            letterSpacing: '-0.035em',
          }}
        >
          {amountDueValue}
        </span>
      </div>
      <Typography variant="body-sm" color="muted" className="mt-3">
        {AMOUNT_DUE_COPY[status]}
      </Typography>
      <div className="text-muted-foreground mt-3.5 border-t pt-3.5 text-[12.5px]">
        Of total{' '}
        <span className="text-foreground font-medium tabular-nums">
          {currFmt.format(total)}
        </span>
      </div>
    </div>
  )
}
